import OffboardL1Page from "../offboard-l1/offboard-l1-page.tsx";
import type { PageProps } from "../../types/page.ts";

export default function OffboardITPage(props: PageProps) {
    return <OffboardL1Page {...props} reviewRole="IT" />;
}
